export function fileInputSummary(file, fallback = "فایلی انتخاب نشده") {
	if (!file?.name) {
		return fallback;
	}
	const name =
		file.name.length > 36 ? `…${file.name.slice(-33)}` : file.name;
	return name;
}
